import { useEffect } from "react";
import { mapValidationErrorToFormDataError } from "../../util/template/error.js";
function handleResetFieldData(form, errorReset = true, warningReset = true) {
    const errors = form.getFieldsError(); // Gets an object containing the validation errors for all fields
    const resetErrors = errors.map((error)=>{
        if (error.errors?.length > 0 || error.warnings?.length > 0) {
            const fieldData = {
                name: error.name,
                errors: error.errors,
                warnings: error.warnings
            };
            if (errorReset === true && fieldData.errors?.length > 0) {
                fieldData.errors = [];
            }
            if (warningReset === true && fieldData.warnings?.length > 0) {
                fieldData.warnings = [];
            }
            return fieldData;
        }
        return undefined;
    }).filter(Boolean);
    if (resetErrors?.length > 0) {
        form.setFields(resetErrors);
    }
}
function useFormValidation(form, errors) {
    useEffect(()=>{
        if (!form) {
            return;
        }
        handleResetFieldData(form);
        if (errors && errors.length > 0) {
            // in an error case, we need to map errors to field data and set it
            const errorFields = mapValidationErrorToFormDataError(errors);
            form.setFields(errorFields);
            // try to scroll to error, bottom up (last matching wins)
            for(let i = errorFields.length - 1; i >= 0; i--){
                const errorField = errorFields[i];
                form.scrollToField(errorField.name);
            }
        }
    }, [
        form,
        errors
    ]);
}
export { useFormValidation };
